// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__RbRPd","errors":"Errors_errors__3IIph"};